import { Pagination, SpliteButton } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { LOCAL_STORAGE, useNewNavigate, usePensionNameValue } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Button, chakra, Flex, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { type RoomListType } from "../../otherRoomPreview.type";

export const OtherRoomInfos = ({
    rooms,
    currentIdx,
    nextSlide,
    prevSlide,
}: {
    rooms: RoomListType[];
    currentIdx: number;
    nextSlide: () => void;
    prevSlide: () => void;
}) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { onNavigate } = useNewNavigate();
    const pensionName = usePensionNameValue();
    const pensionNameEng = LOCAL_STORAGE.get({ key: "pensionNameEng" });
    const { isMobile } = MEDIAS();
    return (
        <Flex flex="1" flexDir="column" h="100%">
            <Flex
                position="relative"
                flexDir="column"
                p={isMobile ? "24px 16px 0 16px" : "80px"}
                rowGap={isMobile ? "24px" : "48px"}
            >
                <Flex flexDir="column" rowGap={isMobile ? "12px" : "32px"}>
                    <Box
                        sx={{
                            "& p": {
                                color: "#664628",
                            },
                        }}
                    >
                        <Text mb={isMobile ? "4px" : "8px"} {...FONT("notoSerif", isMobile ? 14 : 24, 400, 1.4)}>
                            {pensionName}
                        </Text>
                        <Text {...FONT("notoSerif", isMobile ? 20 : 40, 600, 1.4)}>{pensionNameEng} ROOMS</Text>
                    </Box>
                    <Box position="relative" w="100%" minHeight={isMobile ? "190PX" : "269px"}>
                        {rooms.map((t, index) => (
                            <MotionDetailBox
                                display="flex"
                                position="absolute"
                                key={t.room_idx}
                                flexDir="column"
                                rowGap={isMobile ? "16PX" : "32PX"}
                                initial={{ opacity: index === currentIdx ? 1 : 0 }}
                                animate={{
                                    opacity: index === currentIdx ? 1 : 0,
                                    transition: { duration: 0.7, ease: "easeIn" },
                                }}
                            >
                                <Box>
                                    <Text
                                        mb={isMobile ? "8px" : "16px"}
                                        {...FONT("notoSerif", isMobile ? 16 : 32, 400, 1.4)}
                                    >
                                        {t.room_name}
                                    </Text>
                                    <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                                        객실설명
                                    </Text>
                                    <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                                        {t.room_intro}
                                    </Text>
                                </Box>
                                <Box>
                                    <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                                        Room Type
                                    </Text>
                                    <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                                        {" "}
                                        {t.room_type}
                                    </Text>
                                </Box>
                                <Box>
                                    <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                                        Number of People
                                    </Text>
                                    <Flex gap={isMobile ? "8px" : "16px"}>
                                        <Text
                                            color="#6b6b6b"
                                            {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}
                                        >{`기준 ${t.people.min}인 ~ 최대 ${t.people.max}인`}</Text>
                                    </Flex>
                                </Box>
                            </MotionDetailBox>
                        ))}
                    </Box>
                </Flex>
                <Flex justifyContent="space-between">
                    {isMobile && (
                        <Button
                            p="0 24px"
                            h="40px"
                            background="none"
                            border="1px solid #6b6b6b"
                            borderRadius="20px"
                            color="#6b6b6b"
                            {...FONT("notoSerif", 14, 400, 1.4)}
                            onClick={() => {
                                onNavigate({ path: `/rooms/${rooms[currentIdx].room_idx}` });
                                window.scrollTo(0, 0);
                            }}
                        >
                            MoreView
                        </Button>
                    )}
                    <Pagination
                        showPage={false}
                        prevPage={prevSlide}
                        nextPage={nextSlide}
                        colorMode="black"
                        totalPages={rooms.length}
                        currentPage={currentIdx}
                    />
                </Flex>
            </Flex>
            {!isMobile && (
                <Box>
                    <SpliteButton
                        text="More View"
                        onClick={() => onNavigate({ path: `/rooms/${rooms[currentIdx].room_idx}` })}
                    />
                </Box>
            )}
        </Flex>
    );
};

const MotionDetailBox = chakra(motion.div);
